<template>
    <div class="grid grid__dot-cols text-image-row dot-cols dot-cols__base" :class="rootClasses">
        <!-- <pre v-if="content" v-text="content"></pre> -->
        <div class="grid--row dot-cols--row">
            <div class="grid--col dot-cols--col"
                    v-for="(column, index) in content.columns">
                <div v-if="column.text"
                        v-html="column.text">
                </div>
                <img v-if="column.image"
                        class="text-image-row--img"
                        :src="column.image.url" :alt="column.image.alt">
            </div>
        </div>
    </div>
</template>

<script>
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPlugin,
        ],
        computed: {
            rootClasses() {
                return [
                    `dot-cols__col-${ this.content.columns.length }`,
                ];
            },
        },
    };

</script>



// WEBPACK FOOTER //
// index.vue?79a8f1b5